import { useRef } from 'react';

import { FormItemSearch } from '../components/forms/searchFormElements';
import { externalLinks } from '../config/externalLinks';
import { useTrackSearchFormStyles } from './TrackSearchForm.styles';

export default function TrackSearchForm() {
  const { styles } = useTrackSearchFormStyles();
  const form = useRef();
  return (
    <form
      ref={form}
      target="_blank"
      method="POST"
      action={externalLinks.trackSearch}
    >
      <FormItemSearch
        labelId="form.track.label"
        placeholderId="form.track.placeholder"
        formItemComponentProps={{
          className: styles.trackNumberInput,
          name: 'bol',
          size: 'small',
        }}
        onSearch={() => form.current.submit()}
      />
    </form>
  );
}
